import script from "./HeaderAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderAdmin.vue?vue&type=script&setup=true&lang=js"

import "./HeaderAdmin.vue?vue&type=style&index=0&id=fb836ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb836ba0"]])

export default __exports__